var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('homeController', ['$scope', '$interval', 'randomService', 'helperService', 'homeService', 'elasticService', 'storageFactory', 'urlService', 'mainService', 'monthService',
    function ($scope, $interval, randomService, helperService, homeService, elasticService, storageFactory, urlService, mainService, monthService) {

        // Initialize critical data immediately
        $scope.imagesLoaded = false;
        $scope.rightTopAdImagesLoaded = false;
        $scope.activeMainAdIndex = 0;
        $scope.currentMainAd = null;
        $scope.showBottomContent = false;
        $scope.isExecuted = false;

        // Cache DOM selectors
        var $window = angular.element(window);
        
        // Debounce function for scroll/resize events
        function debounce(func, wait) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    func.apply(context, args);
                }, wait);
            };
        }

        // Optimize image loading
        function getWebpImgUrl(imgUrl) {
            if (!imgUrl) return null;
            var lastDotIndex = imgUrl.lastIndexOf(".");
            return lastDotIndex > -1 ? imgUrl.substr(0, lastDotIndex) + ".webp" : null;
        }

        // Optimize data filtering
        function filterData(data, key, value) {
            if (!data || !data.length) return;
            for (var i = 0; i < data.length; i++) {
                if (data[i][key] && data[i][key].toLowerCase() === value.toLowerCase()) {
                    return data[i];
                }
            }
        }

        // Load main content immediately
        $scope.getResetCacheState = function() {
            $scope.resetCache = false;
            getMainAds();
        };

        function getMainAds() {
            var cachedMainAds = helperService.getContent(storageFactory.get("mainAds"));
            
            if (cachedMainAds && !$scope.resetCache) {
                try {
                    cachedMainAds = JSON.parse(cachedMainAds);
                    if (cachedMainAds.length && cachedMainAds[0].webpImageURL) {
                        $scope.mainAds = angular.copy(cachedMainAds);
                        updateCurrentMainAd();
                        $scope.getHomepageContent();
                        return;
                    }
                } catch(e) {}
            }

            homeService.getMainAds().then(function(response) {
                if (response && response.data && response.data.length) {
                    var mainAds = response.data;
                    for (var i = 0; i < mainAds.length; i++) {
                        mainAds[i].webpImageURL = getWebpImgUrl(mainAds[i].imageURL.toLowerCase());
                    }
                    $scope.mainAds = angular.copy(mainAds);
                    updateCurrentMainAd();
                    storageFactory.set("mainAds", JSON.stringify(mainAds), true);
                    $scope.getHomepageContent();
                }
            });
        }

        function updateCurrentMainAd() {
            if ($scope.mainAds && $scope.mainAds.length) {
                $scope.currentMainAd = $scope.mainAds[$scope.activeMainAdIndex];
            }
        }

        // Optimize carousel timer
        var carouselTimer;
        $scope.onCarousalNavClick = function(val) {
            if (carouselTimer) {
                $interval.cancel(carouselTimer);
            }
            
            if ($scope.mainAds && $scope.mainAds.length) {
                if (!($scope.mainAds.length - 1 === $scope.activeMainAdIndex && val > 0) && 
                    !($scope.activeMainAdIndex === 0 && val < 0)) {
                    $scope.activeMainAdIndex = $scope.activeMainAdIndex + val;
                } else {
                    $scope.activeMainAdIndex = 0;
                }
                updateCurrentMainAd();
            }
            
            carouselTimer = $interval($scope.carousalTimerFn, 5000);
        };

        // Lazy load bottom content
        var loadBottomContent = debounce(function() {
            if (!$scope.showBottomContent && window.scrollY > 500) {
                $scope.showBottomContent = true;
                $scope.$apply();
                $window.off('scroll', loadBottomContent);
            }
        }, 100);

        $window.on('scroll', loadBottomContent);

        // Initialize on view load
        $scope.$on('$viewContentLoaded', function() {
            if (!$scope.showTopPicks) {
                $scope.postInitialize();
            }
            
            // Load lookbooks and projects from cache if available
            var lookbooks = helperService.getContent(storageFactory.get("lookbooks"));
            var projects = helperService.getContent(storageFactory.get("projects"));
            
            if (!lookbooks || !projects || $scope.resetCache) {
                $scope.getProjectsAndLookbooks(
                    window.__env.homepageKeys.projectTutorialsCount || 10,
                    window.__env.homepageKeys.lookBooksCount || 5
                );
            } else {
                try {
                    lookbooks = JSON.parse(lookbooks);
                    projects = JSON.parse(projects);
                    if (lookbooks[0] && projects[0]) {
                        processLookbookresponse(lookbooks);
                        processProjectResponse(projects, window.__env.homepageKeys.projectTutorialsCount || 10);
                    } else {
                        $scope.getProjectsAndLookbooks(
                            window.__env.homepageKeys.projectTutorialsCount || 10,
                            window.__env.homepageKeys.lookBooksCount || 5
                        );
                    }
                } catch(e) {
                    $scope.getProjectsAndLookbooks(
                        window.__env.homepageKeys.projectTutorialsCount || 10,
                        window.__env.homepageKeys.lookBooksCount || 5
                    );
                }
            }
            
            $scope.getDigitalEvents();
        });

        $scope.sendGAEvent = function(key) {
            if (typeof gtag !== 'undefined') {
                gtag('event', 'Homepage', {
                    'event_category': 'engagement',
                    'event_action': key
                });
            }
        }

        $scope.$watch('mainAds', function(newVal, oldVal) {
            if (newVal && newVal.length > 0) {
                $scope.imagesLoaded = false;
            }
        });
        $scope.onImageLoad = function() {
            $scope.imagesLoaded = true;
        };

        $scope.rightTopAdImagesLoaded = false;
        $scope.$watch('rightTopAd', function(newVal, oldVal) {
            if (newVal && newVal.length > 0) {
                $scope.rightTopAdImagesLoaded = false;
            }
        });
        $scope.rightTopAdImagesLoad = function() {
            $scope.rightTopAdImagesLoaded = true;
        };

        $scope.activeMainAdIndex = 0;
        $scope.currentMainAd = null;

        function updateCurrentMainAd() {
            if ($scope.mainAds && $scope.mainAds.length > 0) {
                $scope.currentMainAd = $scope.mainAds[$scope.activeMainAdIndex];
            }
        }

        //#region Main Ads
        function getMainAds() {
            homeService.getMainAds().then(
                function (response) {
                    if (response && response.data && response.data.length > 0) {
                        var mainAds = response.data;
                        mainAds.forEach(function(ad){
                            ad.webpImageURL = getWebpImgUrl(ad.imageURL.toLowerCase());
                        });

                        $scope.mainAds = angular.copy(mainAds);
                        updateCurrentMainAd();
                        $scope.getHomepageContent();
                        if ($scope.mainAds.length > 0) {
                            storageFactory.set("mainAds", JSON.stringify($scope.mainAds), true);
                        }
                    }
                }
            )
        }

        $scope.getAdsData = function () {
            var mainAds = helperService.getContent(storageFactory.get("mainAds"));
            if (mainAds == null || $scope.resetCache) {
                getMainAds();
            }
            else {
                mainAds = JSON.parse(mainAds);
                if(angular.isUndefined(mainAds[0]) || angular.isUndefined(mainAds[0].webpImageURL)){
                    getMainAds();
                }
                if (mainAds.length > 0) {
                    $scope.mainAds = angular.copy(mainAds);
                    updateCurrentMainAd();
                }
                $scope.getHomepageContent();
            }
        }
        //#endregion

        // #region HomepageContent
        $scope.getHomepageContent = function () {
            homeService.getHomepageContent().then(
                function (response) {
                    if (response && response.data) {
                        var categories = filterData(response.data, "section", "blueboxBottomAds");
                        if (categories) {
                            $scope.categories = categories.content;
                            $scope.categories.forEach(function(ad){
                                ad.webpImageURL = getWebpImgUrl(ad.image.toLowerCase());
                                ad.webpHoverImageURL = getWebpImgUrl(ad.imageOnHover.toLowerCase());
                            });
                        }

                        var rightAds = filterData(response.data, "section", "blueboxRightAds");
                        if (rightAds && rightAds.content && rightAds.content.length > 0) {
                            var rightTopAd = filterData(rightAds.content, "section", "top");
                            if(rightTopAd && rightTopAd.content){
                                rightTopAd.content.forEach(function(ad){
                                    ad.webpImageURL = getWebpImgUrl(ad.image.toLowerCase());
                                });
                            }
                            $scope.rightTopAd = rightTopAd ? rightTopAd.content : undefined;
                            $scope.activeTopRightAdIndex=0;
                            setInterval(function() {
                                if (angular.isDefined($scope.rightTopAd) && $scope.rightTopAd.length > 0 &&  $scope.activeTopRightAdIndex < $scope.rightTopAd.length-1 ) {
                                    $scope.activeTopRightAdIndex += 1;
                                }
                                else {
                                    $scope.activeTopRightAdIndex=0;
                                }
                            },5000);

                            var rightBottomAd = filterData(rightAds.content, "section", "bottom");
                            if(rightBottomAd && rightBottomAd.content){
                                rightBottomAd.content.forEach(function(ad){
                                    ad.webpImageURL = getWebpImgUrl(ad.image.toLowerCase());
                                    ad.webpHoverImageURL = getWebpImgUrl(ad.imageOnHover.toLowerCase());
                                });
                            }
                            $scope.rightBottomAd = rightBottomAd ? rightBottomAd.content : undefined;
                        }

                        var occasionsData = filterData(response.data, "section", "occasions");
                        var departmentsData = filterData(response.data, "section", "departments");

                        var loadBottomContent = function() {
                            if (occasionsData && occasionsData.content) {
                                occasionsData.content.forEach(function(ad){
                                    ad.webpImageUrl = getWebpImgUrl(ad.imageUrl.toLowerCase());
                                });
                                $scope.occasions = occasionsData.content;
                            }

                            if (departmentsData && departmentsData.content && departmentsData.content.length > 0) {
                                var departmentsAd = filterData(departmentsData.content, "section", "sidebar");
                                $scope.departmentsAd = departmentsAd ? departmentsAd : undefined;

                                var marketingLinks = filterData(departmentsData.content, "section", "marketinglinks");
                                $scope.departments = marketingLinks ? marketingLinks.content : undefined;

                                if ($scope.departments) {
                                    $scope.departments.forEach(function(ad){
                                        ad.webpImageURL = getWebpImgUrl(ad.image.toLowerCase());
                                        ad.webpHoverImageURL = getWebpImgUrl(ad.imageOnHover.toLowerCase());
                                    });
                                }
                            }

                            $scope.$apply();
                        };

                        var autoLoadTimeout = setTimeout(function() {
                            loadBottomContent();
                            $scope.postInitialize();
                        }, 3000);

                        // Still allow earlier loading on scroll or resize
                        var earlyLoadBottomContent = function() {
                            if (window.scrollY > 500 || window.innerWidth <= 768) {
                                clearTimeout(autoLoadTimeout);
                                $scope.postInitialize();
                                loadBottomContent();
                                window.removeEventListener('scroll', earlyLoadBottomContent);
                                window.removeEventListener('resize', earlyLoadBottomContent);
                            }
                        };

                        var earlyLoadPostInitialize = function() {
                            if (window.innerWidth <= 768 && (window.scrollY > 100 || window.innerHeight < 800)) {
                                $scope.postInitialize();
                                window.removeEventListener('scroll', earlyLoadPostInitialize);
                                window.removeEventListener('resize', earlyLoadPostInitialize);
                            } else if (window.innerHeight >= 800 || window.innerWidth > 768) {
                                $scope.postInitialize();
                                window.removeEventListener('scroll', earlyLoadPostInitialize);
                                window.removeEventListener('resize', earlyLoadPostInitialize);
                            }
                        };

                        window.addEventListener('scroll', earlyLoadBottomContent);
                        window.addEventListener('resize', earlyLoadBottomContent);
                        window.addEventListener('resize', earlyLoadPostInitialize);
                    }
                }
            );
        }
        //#endregion

        window.onload = function () {
            if(!$scope.showTopPicks){
                $scope.postInitialize();
            }
            $scope.lookBooksCount = (angular.isDefined(window.__env.homepageKeys) && window.__env.homepageKeys.lookBooksCount > 0) ? window.__env.homepageKeys.lookBooksCount : 5;
            $scope.projectTutorialsCount = (angular.isDefined(window.__env.homepageKeys) && window.__env.homepageKeys.projectTutorialsCount > 0) ? window.__env.homepageKeys.projectTutorialsCount : 10;

            var lookbooks = helperService.getContent(storageFactory.get("lookbooks"));
            var projects = helperService.getContent(storageFactory.get("projects"));
            
            if (projects == null || lookbooks == null || $scope.resetCache) {
                $scope.getProjectsAndLookbooks($scope.projectTutorialsCount, $scope.lookBooksCount);
            }
            else {
                lookbooks = JSON.parse(lookbooks);
                projects = JSON.parse(projects);
                if (angular.isUndefined(lookbooks[0]) || angular.isUndefined(projects[0])) {
                    $scope.getProjectsAndLookbooks($scope.projectTutorialsCount, $scope.lookBooksCount);
                }
                if (lookbooks.length > 0) {
                    processLookbookresponse(lookbooks);
                    processProjectResponse(projects, $scope.projectTutorialsCount);
                }
            }
            
            $scope.getDigitalEvents();
        }

        $scope.getProjectsAndLookbooks = function (projectCount, lookbookCount) {
            homeService.getProjectsAndLookbooks(projectCount, lookbookCount).then(function (data) {
                if (data && data.data) {
                    storageFactory.set("lookbooks", JSON.stringify(data.data.lookbooks), true);
                    storageFactory.set("projects", JSON.stringify(data.data.projects), true);

                    processLookbookresponse(data.data.lookbooks);
                    processProjectResponse(data.data.projects, $scope.projectTutorialsCount);
                }
            });
        };
        

        //#region Helper Functions

        function getWebpImgUrl(imgUrl){
            if(angular.isDefined(imgUrl) && imgUrl.length > 0){
                return imgUrl.substr(0, imgUrl.lastIndexOf(".")) + ".webp";
            }
            else{
                return null;
            }
        }

        function filterData(data, key, value) {
            var filteredData = data.filter(
                function (data) {
                    return (data[key] && data[key].toLowerCase()) == value.toLowerCase()
                }
            );
            return (filteredData && filteredData != null && filteredData.length > 0) ? filteredData[0] : undefined;
        }

        $scope.showAlert = function(message){
            alert(message);
        }
        //#endregion

        $scope.postInitialize = function(){
            if (!$scope.isExecuted) {
                $scope.isExecuted = true;
                $scope.showTopPicks = true;
                getNewArrivals();
            }
        }

        //#region New Arrivals
        function getNewArrivals() {
            elasticService.getElasticData(elasticService.buildNewArrivalsRequest(
                ["StockDesign", "DesignPack"], 100
            )).then(
                function (response) {
                    if (response && 'aggregations' in response.data) {
                        var newArrivals = response.data.aggregations.definitions.buckets;
                        $scope.newDesigns = randomService.getRandomItemsfromListArray(
                            filterData(newArrivals, "key", "StockDesign").topByDefinitions.hits.hits
                        );
                        var newPacks = randomService.getRandomItemsfromListArray(
                            filterData(newArrivals, "key", "DesignPack").topByDefinitions.hits.hits
                        );
                        newPacks.forEach(
                            function(f){
                                if(f && f._source && f._source.variants && f._source.variants.length > 0){
                                    f._source.desc = f._source.variants[0].numberOfDesigns + " Designs in 1 Pack";
                                }
                            }
                        );
                        $scope.newPacks = newPacks;
                    }
                }
            ).then(
                elasticService.getElasticData(elasticService.buildNewArrivalsRequest(
                    ["Font", "Supplies", "Sewing PDF Patterns", "Clothing PDF Patterns","Merchandise","Machine","Fabric"], 50)
                ).then(
                    function (response) {
                        if (response && 'aggregations' in response.data) {
                            var newArrivals = response.data.aggregations.definitions.buckets;
                           // Function to get hits.hits from filterData result
                           function getHitsFromFilterData(key) {
                                var filteredData = filterData(newArrivals, "key", key);
                                return filteredData && filteredData.topByDefinitions ? filteredData.topByDefinitions.hits.hits : [];
                            }

                            $scope.newFonts = randomService.getRandomItemsfromListArray(getHitsFromFilterData("Font"));
                            $scope.newSupplies = randomService.getRandomItemsfromListArray(getHitsFromFilterData("Supplies"));
                            $scope.pdfPatterns = randomService.getRandomItemsfromListArray(getHitsFromFilterData("Sewing PDF Patterns"));
                            $scope.clothingPatterns = randomService.getRandomItemsfromListArray(getHitsFromFilterData("Clothing PDF Patterns"));
                            $scope.merchandiseProducts = randomService.getRandomItemsfromListArray(getHitsFromFilterData("Merchandise"));
                            $scope.machine = randomService.getRandomItemsfromListArray(getHitsFromFilterData("Machine"));
                            $scope.fabricProducts = randomService.getRandomItemsfromListArray(getHitsFromFilterData("Fabric"));
                        }
                    }
                )
            );
        }
        //#endregion

        //#region Digital Events
        $scope.getDigitalEvents = function () {
            $scope.eventBannerimgPath = window.__env.digitalEventImgBaseUrl;
            mainService.getSettingsByKey(window.__env.displayHomepageEventsKey).then(
                function(response){
                    if (response && response.data) {
                        $scope.showEvents = (response.data.toLowerCase() == 'true');
                        if($scope.showEvents){
                            var count = (angular.isDefined(window.__env.homepageKeys) && window.__env.homepageKeys.digitalEventsCount > 0 )? window.__env.homepageKeys.digitalEventsCount : 2;
                            homeService.getDigitalEvents(count).then(
                                function (response) {
                                    if (response && response.data) {
                                        var events = response.data;

                                        $scope.events = events.map(function (event) {
                                            try {
                                                // Extract date and time parts from eventStartDate
                                                var dateParts = event.goLive.split("T");
                                                var datePart = dateParts[0]; // Extract YYYY-MM-DD
                                                var timePart = dateParts[1].replace("Z", ""); // Extract HH:MM:SS

                                                // Parse the date (YYYY-MM-DD)
                                                var dateArray = datePart.split("-");
                                                var year = parseInt(dateArray[0], 10); // Extract year
                                                var month = parseInt(dateArray[1], 10); // Extract month (1-12)
                                                var day = parseInt(dateArray[2], 10); // Extract day

                                                // Parse the time (HH:MM:SS)
                                                var timeArray = timePart.split(":");
                                                var hours = parseInt(timeArray[0], 10); // Extract hours
                                                var minutes = parseInt(timeArray[1], 10); // Extract minutes

                                                // Calculate eventEndTime
                                                var totalMinutes = hours * 60 + minutes + event.eventDuration;
                                                var endHours = Math.floor(totalMinutes / 60) % 24; // Wrap-around for 24-hour format
                                                var endMinutes = totalMinutes % 60;

                                                // Format eventStartTime and eventEndTime in HH:MM
                                                var formattedStartTime =
                                                    (hours < 10 ? "0" + hours : hours) + ":" +
                                                    (minutes < 10 ? "0" + minutes : minutes);
                                                var formattedEndTime =
                                                    (endHours < 10 ? "0" + endHours : endHours) + ":" +
                                                    (endMinutes < 10 ? "0" + endMinutes : endMinutes);

                                                // Format eventDate (e.g., December 20, 2024)
                                                var monthName = monthService.monthNames[month - 1]; // Use monthService to get month name
                                                var formattedEventDate = monthName + " " + day + ", " + year;

                                                // Add all calculated properties to the event object
                                                return Object.assign({}, event, {
                                                    eventStartTime: formattedStartTime,
                                                    eventEndTime: formattedEndTime,
                                                    eventDate: formattedEventDate
                                                });
                                            } catch (error) {
                                                console.error("Error processing event:", error);
                                                return event;
                                            }
                                        });
                                    }
                                }
                            );
                        }
                    }
                }
            )
        }
        //#endregion

        //#region Lookbooks
        function processLookbookresponse(data) {
            var lookbooks = randomService.getRandomItemsfromListArray(
                data, 3
            );
            if (lookbooks && lookbooks.length > 0) {
                $scope.lookbooksAdImg = lookbooks[0];
                if (lookbooks.length > 2) {
                    $scope.lookbooksAdImg = lookbooks.pop();
                }
                $scope.lookbooksAdImg["imgUrl"] = urlService.getImageUrl(
                    {
                        "definitionName": "lookbook",
                        "lookbookId": $scope.lookbooksAdImg.lookbookId
                    }
                );
                $scope.lookbooks = lookbooks;
            }
        }
        //#endregion

        //#region Get Projects
        function processProjectResponse(data, count) {
            $scope.homePageProjects = randomService.getRandomItemsfromListArray(
                data, count
            );
        }
        //#endregion

        //#region Carousal Timer and Nav click related
        $scope.carousalTimerFn = function () {
            $scope.onCarousalNavClick(1);
        }
        $scope.carousalInterval = $interval($scope.carousalTimerFn, 5000);
        $scope.onCarousalNavClick = function (val) {
            $interval.cancel($scope.carousalInterval);
            if ($scope.mainAds && $scope.mainAds.length > 0) {
                if (!(($scope.mainAds.length - 1 == $scope.activeMainAdIndex && Number(val) > 0) || ($scope.activeMainAdIndex == 0 && Number(val) < 0))) {
                    $scope.activeMainAdIndex = Number($scope.activeMainAdIndex) + Number(val);
                }
                else {
                    $scope.activeMainAdIndex = 0;
                }
                updateCurrentMainAd();
            }
            $scope.carousalInterval = $interval($scope.carousalTimerFn, 5000);
        }
        //#endregion

        var bottomContentLoaded = false;
        var loadBottomContent = function() {
            if (!bottomContentLoaded && window.scrollY > 500) {
                $scope.showBottomContent = true;
                bottomContentLoaded = true;
                window.removeEventListener('scroll', loadBottomContent);
            }
        };

        window.addEventListener('scroll', loadBottomContent);

        $scope.$on('$viewContentLoaded', function() {
            window.addEventListener('scroll', loadBottomContent);
            loadBottomContent();
        });
      
        // Cleanup on scope destroy
        $scope.$on('$destroy', function() {
            if (carouselTimer) {
                $interval.cancel(carouselTimer);
            }
            $window.off('scroll', loadBottomContent);
        });
    }
]);
